import React, { useState } from "react";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import { asyncGetProfile } from "lib/store/user";
import {
  customToastState,
  errorToastState,
  modalState,
} from "lib/store/common";
import { addCard, cardInfoType, updateCardInfo } from "lib/store/billing";

import { Button, Checkbox, Hr, Input, Modal } from "@atsent/components";

import "./AddCard.scss";

export type AddCardProps = {
  cx?: string;
};

const usePaymentInfo = () => {
  const profile = useRecoilValueLoadable(asyncGetProfile);

  const returnVal: {
    state: any;
    username: any;
  } = {
    state: profile.state,
    username: null,
  };

  if (profile.state === "hasValue") {
    returnVal.username = profile.contents.username;
  }

  return returnVal;
};
export const AddCard: React.FC<AddCardProps> = ({ cx = "" }) => {
  const { username } = usePaymentInfo();
  const setErrorToast = useSetRecoilState(errorToastState);
  const setToast = useSetRecoilState(customToastState);
  const refreshCardData = useSetRecoilState(updateCardInfo);
  const setModal = useSetRecoilState(modalState);
  const [cardInfo, setCardInfo] = useState<cardInfoType>({
    card_number: "",
    expiry: "",
    birth: "",
    pwd_2digit: "",
    customer_uid: "",
  });

  const handleClose = async () =>
    setModal((_) => ({ ..._, myAccount: true, addCard: false }));

  const handleAddCard = async () => {
    try {
      await addCard(cardInfo);
      await setToast({
        type: "success",
        text: "카드 등록이 완료되었습니다..",
      });
      await refreshCardData(new Date());
      await handleClose();
    } catch (e) {
      setErrorToast(e);
    }
  };

  return (
    <Modal
      title={"Payment Method"}
      cx={`AddCard ${cx}`}
      close={() => handleClose()}
    >
      <Input
        label={"카드 번호"}
        type={"password"}
        placeholder={"XXXXXXXXXXXX"}
        maxlength={16}
        passwordVisible
        handleOnChange={(e) => {
          setCardInfo((_) => ({
            ..._,
            card_number: e.target.value,
            customer_uid: `${username}_${e.target.value.slice(
              e.target.value.length - 4
            )}`,
          }));
        }}
      />
      <Input
        label={"카드 유효 기간"}
        type={"password"}
        placeholder={"YYYYMM"}
        maxlength={6}
        passwordVisible
        handleOnChange={(e) =>
          setCardInfo((_) => ({ ..._, expiry: e.target.value }))
        }
      />
      <Input
        label={"생년월일/사업자번호"}
        type={"password"}
        placeholder={"YYMMDD"}
        passwordVisible
        maxlength={10}
        handleOnChange={(e) =>
          setCardInfo((_) => ({ ..._, birth: e.target.value }))
        }
      />
      <Input
        label={"카드 비밀번호 앞 두자리"}
        placeholder={"XX"}
        passwordVisible
        maxlength={2}
        handleOnChange={(e) =>
          setCardInfo((_) => ({ ..._, pwd_2digit: e.target.value }))
        }
      />
      {/*<Input size={"small"} label={"Detail Address"} />*/}
      <Button
        cx={"center"}
        click={() => handleAddCard()}
      >
        카드 등록
      </Button>
    </Modal>
  );
};